import MetaComponent from '../../components/MetaComponent';
import InnerHeader from '../../layout/InnerHeader';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WardrobeContent from './WardrobeContent';
import TopColContent1 from './TopColContent1';
import TopColContent2 from './TopColContent2';
import WardrobeHeading from './WardrobeHeading';
import ValueWardrobe from './ValueWardrobe';

function WardrobesIntro() {

    const [data,setData]=useState([])
    useEffect(()=>{
        axios.get('https://www.kitchendesign.ae/apis/wp-json/api/v4/getwardrobepage????????????')
        .then(res=>{
            setData(res.data);
        })
        .catch(err=>{
            // console.log(err);
        })
    },[])
    console.log(data);
return (
  <div className="WardrobesIntro"> 
    <MetaComponent title={data.meta_title} description={data.meta_description}/>
    <InnerHeader pagename={data?.acf?.header_heading} pagedesc={data?.acf?.pagedesc} imageurl={data?.acf?.header_image?.url} CustomClass="SmallInnerHeader"/>
    <WardrobeContent content={data.acf?.content} />
    <TopColContent1 image={data.acf?.wc1_img} content={data.acf?.wc1_text}/>
    <TopColContent2 image={data.acf?.wc2_img} content={data.acf?.wc2_text}/>
    <WardrobeHeading content={data.acf?.wardrobe_content}/>
  </div>
)
}

  export default WardrobesIntro;